import AudioHandler from "./AudioHandler";
import GameHandler from "./GameHandler";
import InputHandler from "./InputHandler";
import NotificationHandler from "./NotificationHandler";
export default {
    AudioHandler: AudioHandler,
    GameHandler: GameHandler,
    InputHandler: InputHandler,
    NotificationHandler: NotificationHandler,
};
